import classNames from "classnames";
import { SvgClose } from "components/svg";
import React, { type PropsWithChildren, type RefObject, useRef, useState } from "react";
import { createPortal } from "react-dom";
import Draggable from "react-draggable";
//import Button from "../button";

import { v4 as uuidv4 } from "uuid";

export type PopupProps = PropsWithChildren<{
  fullscreen?: boolean;
  noHeader?: boolean;
  onClose: () => void;
  fixSize?: string;

  closeOnOutsideClick?: boolean;
  refOpener?: RefObject<HTMLElement>;
  title?: string;
  coloredTitle?: boolean;
  wrapTitle?: boolean;
  portal?: boolean;
  noHorizontalLine?: boolean;
}>;

const Popup: React.FC<PopupProps> = ({
  fullscreen = false,
  noHeader = false,
  onClose,
  closeOnOutsideClick = false,
  children,
  title = "",
  fixSize,
  coloredTitle = false,
  wrapTitle = false,
  portal,
  noHorizontalLine = false
}) => {
  const [guid] = useState(uuidv4()); //NOSONAR
  const containerRef = useRef<HTMLDivElement>(null);

  const elementRef = useRef<HTMLDivElement>(null);

  let innerContent = (
    <div ref={elementRef} className={"handle_" + guid} >
      {!noHeader && (
        <group

          {...(coloredTitle
            ? { "data-background": "main", "data-color": "white" }
            : { "data-background": "main-background" })}
          data-space="20"
          //data-space-horizontal="40"
          data-space-bottom="5"
          data-gap="5"

        >
          {wrapTitle ?
            <group data-wrap="no" data-align="center" data-height="auto" >
              <text
                data-weight="400"
                data-color="main"
                data-text-size="x-large"
                data-name="popup_title"
                data-wrap="wrap"
                data-max-length='700'
              >
                {title}
              </text>
              <group
                data-color="secondary"
                className="close"
                data-width="auto"
                data-position="right"
                data-cursor="pointer"
                data-interactive=""
                data-transparent=""
                data-radius="5"
                onClick={onClose}
              >
                <icon data-svg-color="secondary" data-svg-size="12" data-length="30" data-height="30" data-space="5"><SvgClose></SvgClose></icon>
              </group>
            </group>
            :
            <group data-wrap="no" data-align="center"  >

              <text
                data-weight="400"
                //data-space="10"
                data-ellipsis=""
                data-color="main"
                data-text-size="x-large"
                data-name="popup_title"
              >
                {title}
              </text>
              <group
                data-color="secondary"
                className="close"
                data-width="auto"
                data-position="right"
                data-cursor="pointer"
                data-interactive=""
                data-transparent=""
                data-radius="5"
                onClick={onClose}
              >
                <icon data-svg-color="secondary" data-svg-size="12" data-length="30" data-height="30" data-space="5"><SvgClose></SvgClose></icon>
              </group>
            </group>
          }
          {!noHorizontalLine && <separator data-horizontal="" data-margin="none"></separator>}
        </group>
      )}
      <div>
        <div
          id="windowContent"
          className="window_cont"
          fixed={fixSize} //NOSONAR
        >
          {children}
        </div>
      </div>
    </div>
  );
  if (!fullscreen) {
    innerContent = (
      <Draggable
        nodeRef={elementRef as any}
        cancel=".window_cont,.close"
        bounds="parent"
        handle={".handle_" + guid}
      >
        {innerContent}
      </Draggable>
    );
  }

  const content = (
    <div
      ref={containerRef}
      className={classNames("popup", "open", { fullscreen })}
      onClick={(e) => {
        if (closeOnOutsideClick && e.target === containerRef.current) {
          onClose();
        }
      }}
    >
      {innerContent}
    </div>
  );

  if (!portal) {
    return content;
  }

  return createPortal(
    content,
    document.getElementById("popup-root") as HTMLElement
  );
};

export default Popup;
